import styles from './timelineList.module.css';

const TimelineList = ({ items, showTimeline = true, className = '' }) => {
    return (
        <div className={`${styles.timelineList} ${className}`} data-show-timeline={showTimeline}>
            {items.map((item, index) => (
                <TimelineItem key={index} item={item} />
            ))}
        </div>
    );
};

const TimelineItem = ({ item }) => {
    const IconComponent = item.icon;

    return (
        <div className={styles.timelineItem}>
            <div className={styles.iconContainer}>
                <IconComponent size={20} />
            </div>
            <div className={styles.itemContent}>
                {item.title && (
                    item.desc ? (
                        // Pour les services (titre + description)
                        <p>
                            <strong>{item.title}</strong>
                        
                            <span dangerouslySetInnerHTML={{ __html: item.desc }}></span>
                        </p>
                    ) : (
                        // Pour les valeurs (titre h4 + description p)
                        <>
                            <h4>{item.title}</h4>
                            <p>{item.desc}</p>
                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default TimelineList;
